export default {
  name: "BolideAssistantHeader",

  props: {
    title: {
      type: String,
      default: "AI Dashboard Assistant",
    },
    is_fullscreen: Boolean,
    is_history_open: Boolean,
  },

  emits: [
    "toggle-history",
    "new-conversation",
    "toggle-fullscreen",
    "close",
  ],
};
